export class Expression {
    public constructor(expr: string) {
        this.Expr = expr;
    }

    public Expr: string;
}